import styled from 'styled-components';

import { ButtonWrapper } from 'src/pages/gantt/gantt-calendar/gantt-view/components/gantt-popover/gantt-popover.styles';

export const EmployeeActionsWrapper = styled(ButtonWrapper)`
  justify-content: space-between;
  & > div:last-child {
    display: flex;
    align-items: center;
    & > div {
      cursor: pointer;
    }
    & > div:last-child {
      margin-left: 30px;
    }
  }
`;
